import React from "react";
import { Instagram, Youtube, Apple } from "lucide-react";
import { OFFICIAL_LINKS } from "@/lib/link";

export function SpotifyGlyph({ className = "w-5 h-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <path d="M7 9.5c3.5-1 7-.5 10 1.2M7.5 13c3-.8 5.8-.4 8.3 1M8 16.2c2.4-.6 4.6-.3 6.6.8" />
    </svg>
  );
}

/** Social links — Instagram, YouTube, Apple Music, Spotify (@okaytwitchy). */
export default function SocialLinks({ layout = "row" }) {
  const items = [
    { id: "instagram", label: "Instagram", icon: Instagram, url: OFFICIAL_LINKS.instagram },
    { id: "youtube", label: "YouTube", icon: Youtube, url: OFFICIAL_LINKS.youtube },
    { id: "apple-music", label: "Apple Music", icon: Apple, url: OFFICIAL_LINKS.apple_music },
    { id: "spotify", label: "Spotify", icon: SpotifyGlyph, url: OFFICIAL_LINKS.spotify },
  ];

  return (
    <div className={layout === "row" ? "flex flex-wrap items-center gap-3" : "flex flex-col gap-3"}>
      {items.map((i) => (
        <button
          key={i.id}
          data-testid={`social-link-${i.id}`}
          onClick={() => window.open(i.url, "_blank", "noopener,noreferrer")}
          aria-label={`Okaytwitchy on ${i.label}`}
          className="min-w-[56px] h-[56px] px-4 border border-[#2A2A36] bg-[#0F0F14] hover:border-[#F26522] hover:text-[#F26522] text-white flex items-center justify-center gap-2 transition-colors"
        >
          <i.icon className="w-5 h-5" aria-hidden="true" />
          {layout === "column" && <span className="font-display font-bold uppercase text-sm tracking-widest">{i.label}</span>}
        </button>
      ))}
    </div>
  );
}
